"use client"; // Mark this as a Client Component

import React from "react";
import { CheckCircle, Phone } from "lucide-react";

type ConditionsPillsProps = {
  title: string;
  conditions: string[];
};

export const ConditionsPills: React.FC<ConditionsPillsProps> = ({ title, conditions }) => {
  const items = Array.from(new Set(conditions.map((s) => s?.trim()).filter(Boolean) as string[]))
    .sort((a, b) => a.localeCompare(b));

  const handleOpenActions = () => {
    // Dispatch the event to open the floating actions
    const event = new Event("floatingCart:openQuickActions");
    window.dispatchEvent(event);
  };

  return (
    <section className="mx-auto max-w-5xl">
      <h2 className="text-center text-2xl md:text-3xl font-bold text-white mb-6">{title}</h2>

      <ul role="list" className="flex flex-wrap gap-2">
        {items.map((c) => (
          <li key={c}>
            <span className="inline-flex items-center gap-2 rounded-full bg-white/5 px-3 py-1.5 text-white text-sm ring-1 ring-white/10 hover:bg-white/10 transition">
              <CheckCircle aria-hidden className="h-4 w-4 text-[var(--color-link)]" />
              <span>{c}</span>
            </span>
          </li>
        ))}
      </ul>

      {/* CTA Button */}
      <div className="mt-8 text-center">
        <button
          onClick={handleOpenActions}
          className="inline-flex items-center gap-2 rounded-lg bg-[var(--color-link)] px-4 py-2 text-white text-sm font-semibold shadow-md hover:bg-[var(--color-link)]/60 transition"
        >
          <Phone className="h-4 w-4" />
          See Call Options
        </button>
      </div>
    </section>
  );
};